import { bindActionCreators } from 'redux';
import { removeParams } from 'ggApp/modules/router/actions';
import { connect } from 'react-redux';
import Payment from './Payment';

export default connect(null, (dispatch) => ({
    removeUrlParams: bindActionCreators(removeParams, dispatch),
}))(Payment);
